import React from 'react';
import PropTypes from 'prop-types';

const EpLocalLoading = ({ customClass }) => (
  <div className={`spinner-border ${customClass}`} role="status">
    <span className="visually-hidden" />
  </div>
);

export default EpLocalLoading;

EpLocalLoading.defaultProps = {
  customClass: '',
};

EpLocalLoading.propTypes = {
  customClass: PropTypes.string,
};
